import React, { useRef, useState } from "react";
// import TiltText from "../components/TiltText";
import Page1Bottom from "../components/Page1Bottom";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import TiltText from "../components/TiltText";

const Page1 = () => {
  const tiltRef = useRef(null);
  const [xVal, setXVal] = useState(0);
  const [yVal, setYVal] = useState(0);

  const mouseMoving = (e) => {
    // This effect will only run on devices with a mouse
    setXVal((e.clientX - tiltRef.current.getBoundingClientRect().x - tiltRef.current.getBoundingClientRect().width/2)/50);
    setYVal(-(e.clientY - tiltRef.current.getBoundingClientRect().y - tiltRef.current.getBoundingClientRect().height/2)/15);
  }

  useGSAP(function(){
    gsap.to(tiltRef.current,{
      transform : `rotateX(${yVal}deg) rotateY(${xVal}deg)`,
      duration: 2,
      ease: 'power4.out'
    })
  },[xVal,yVal])

  
  return (
    <div 
      id="page1" 
      onMouseMove={(e)=>{
        // On touch devices, this event won't fire, so the tilt will not activate
        mouseMoving(e);
      }}
      // 👇 Padding adjusted for mobile and desktop screens
      className="h-screen w-full relative p- md:p-7 bg-backgroundImg overflow-hidden bg-cover bg-center bg-no-repeat"
    >
      
      
      <div id="page1-in" className="flex justify-center items-center p-4 h-full">
        <TiltText abc={tiltRef} />
      </div>
      
      <Page1Bottom />
    </div>
  );
}

export default Page1;